<!--
  ~ Copyright © 2018 DV Bern AG, Switzerland
  ~
  ~ Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
  ~ geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
  ~ insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
  ~ elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
  ~ Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
  -->

<div class="elohn-pdf-print">
    <button mat-raised-button
            color="primary"
            i18n-matTooltip="@@pdf-print-component.print-current.tooltip"
            matTooltip="Nur aktuell geöffneten Lohnausweis drucken"
            i18n="@@pdf-print-component.print-current"
            [disabled]="isPrintCurrentDisabled()"
            (click)="printCurrent()">
        <mat-icon class="mat-icon-20">print</mat-icon>
        nur diesen LA
    </button>
    <button mat-raised-button
            color="primary"
            i18n-matTooltip="@@pdf-print-component.print-all.tooltip"
            matTooltip="Alle erfassten Lohnausweise in ein PDF drucken"
            i18n="@@pdf-print-component.print-all"
            [disabled]="isPrintAllDisabled()"
            (click)="printAll()">
        <mat-icon class="mat-icon-20">print</mat-icon>
        alle LA
    </button>
</div>
<div class="elohn-pdf-print">
    <button mat-raised-button
            color="primary"
            i18n-matTooltip="@@pdf-print-component.daten-loeschen.tooltip"
            matTooltip="alle im Browser gespeicherten Daten löschen"
            (click)="clearAll()"
            i18n="@@pdf-print-component.daten-loeschen">
        <mat-icon class="mat-icon-20">delete</mat-icon>
        Alle Daten löschen
    </button>
</div>
